<template>
  <v-navigation-drawer v-if="isAuth" app permanent expand-on-hover>
    <v-list>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>{{ fullname }} ({{ role }})</v-list-item-title>
          <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-divider></v-divider>

    <div v-if="!isGuide">
      <v-list v-if="isAuth" nav dense>
        <v-list-item
          link
          to="/life"
          v-if="user.subroles.find((sr) => sr == 1) || user.role_id == 1"
        >
          <BlueberryIcon name="LifeBtn" />
          <v-list-item-title>Life</v-list-item-title>
        </v-list-item>
        <v-list-item
          link
          to="/health"
          v-if="user.subroles.find((sr) => sr == 2) || user.role_id == 1"
        >
          <BlueberryIcon name="LifeBtn" />
          <v-list-item-title>Health</v-list-item-title>
        </v-list-item>
        <!-- <v-list-item link to="/auto">
          <BlueberryIcon name="AutoBtn" />
          <v-list-item-title>Auto</v-list-item-title>
        </v-list-item>
        <v-list-item link to="/pet">
          <BlueberryIcon name="PetBtn" />
          <v-list-item-title>Pet</v-list-item-title>
        </v-list-item>
        <v-list-item link to="/home">
          <BlueberryIcon name="HomeBtn" />
          <v-list-item-title>Home</v-list-item-title>
        </v-list-item>
        <v-list-item link to="/motorcycle">
          <BlueberryIcon name="MotoBtn" />
          <v-list-item-title>Moto</v-list-item-title>
        </v-list-item>
        <v-list-item link to="/renters">
          <BlueberryIcon name="RentersBtn" />
          <v-list-item-title>Renters</v-list-item-title>
        </v-list-item> -->
      </v-list>

      <v-divider></v-divider>

      <v-list v-if="isAuth && user.role_id == 1" nav dense>
        <v-list-item link to="/raw-leads">
          <v-list-item-title>Raw Leads</v-list-item-title>
        </v-list-item>
      </v-list>
      <v-list v-if="isAuth" nav dense>
        <v-list-item link to="/follow-ups">
          <v-list-item-title>Follow-ups</v-list-item-title>
        </v-list-item>
      </v-list>
      <v-list v-if="isAuth && user.role_id === 1" nav dense>
        <v-list-item link to="/records">
          <v-list-item-title>Records</v-list-item-title>
        </v-list-item>
      </v-list>
      <v-list v-if="isAuth" nav dense>
        <v-list-item link to="/statistic">
          <v-list-item-title>Statistic</v-list-item-title>
        </v-list-item>
      </v-list>
      <v-list v-if="isAuth && user.role_id == 1" nav dense>
        <v-list-item link to="/deals">
          <v-list-item-title>Deals</v-list-item-title>
        </v-list-item>
      </v-list>
    </div>
    <div v-else-if="isGuide">
      <v-list-item link to="/guide/leads">
        <v-list-item-title>Leads</v-list-item-title>
      </v-list-item>
      <v-list-item link to="/guide/missed-calls">
        <v-list-item-title>Missed Calls</v-list-item-title>
      </v-list-item>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";
import BlueberryIcon from "@/components/BlueberryIcon";

export default {
  components: {
    BlueberryIcon,
  },
  computed: {
    ...mapGetters({
      authentificated: "auth/authentificated",
      user: "auth/user",
      isAuth: "auth/isAuth",
      isGuide: "auth/isGuide",
      fullname: "auth/fullname",
      role: "auth/role",
    }),
  },
};
</script>
